import React from "react";
import { BigCalendar } from "../../ui/calendar-large";
import { Card, CardContent } from "../../ui/card";
import { SummaryHeader } from "../../ui/SummaryHeader";
import type { CalendarEvent } from "../../../types/types";

interface CalendarEventsProps {
  events: CalendarEvent[];
  selectedDate: Date | undefined;
  onDateSelect: (date: Date | undefined) => void;
}

export function getEventDates(events: CalendarEvent[]): Date[] {
  const dates: Date[] = [];
  events.forEach((evt) => {
    const start = new Date(evt.startAt);
    const end = new Date(evt.endAt);
    for (
      let d = new Date(start);
      d <= end;
      d.setDate(d.getDate() + 1)
    ) {
      dates.push(new Date(d));
    }
  });
  return dates;
}

export const CalendarEvents: React.FC<CalendarEventsProps> = ({
  events,
  selectedDate,
  onDateSelect,
}) => {
 

  return (
    <>
      <SummaryHeader title="Calendar" />
      <Card>
        <CardContent>
          <BigCalendar
            events={events} // Use the original events array
            selectedDate={selectedDate}
            onDateSelect={onDateSelect}
          />
        </CardContent>
      </Card>
    </>
  );
};